import React, { useEffect, useRef } from 'react';

import { useNode } from '@craftjs/core';

import PropTypes from 'prop-types';
import { EDITOR_RESOLVERS } from '@common/constants';

const PageHeader = ({ children, height }) => {
  const {
    connectors: { connect, drag },
    actions: { setCustom },
  } = useNode();
  const ref = useRef(null);

  useEffect(() => {
    if (ref?.current && connect) {
      connect(drag(ref.current));
    }
  }, [connect]);

  return (
    <div style={{ height: `${height || 50}px` }} ref={ref}>
      {children}
    </div>
  );
};

export const PageHeaderDefaultProps = {
  background: '#ffffff',
  paddingLeft: '5',
  paddingRight: '5',
  paddingTop: '5',
  paddingBottom: '5',
  children: null,
};

PageHeader.propTypes = {
  background: PropTypes.string,
  paddingLeft: PropTypes.string,
  paddingRight: PropTypes.string,
  paddingTop: PropTypes.string,
  paddingBottom: PropTypes.string,
  children: PropTypes.node,
};

PageHeader.craft = {
  displayName: EDITOR_RESOLVERS.PDF.PAGE_HEADER,
  name: EDITOR_RESOLVERS.PDF.PAGE_HEADER,
  props: PageHeaderDefaultProps,
};

export default PageHeader;
